// Iter 55 — Formato codice commessa CONFIGURABILE (SaaS Fase 1).
// Default identico allo storico: prefisso "EG", 2 cifre cliente, 3 cifre
// commessa. Il formato reale viene caricato all'avvio da AppLayout tramite
// GET /api/commesse/formato e impostato con setCommessaFormat().
let FORMAT = { prefix: "EG", cifreCliente: 2, cifreNumero: 3 };

export const setCommessaFormat = (f) => {
  if (!f) return;
  FORMAT = {
    prefix: (f.prefix || "EG").toUpperCase(),
    cifreCliente: Number(f.cifre_cliente) || 2,
    cifreNumero: Number(f.cifre_numero) || 3,
  };
};

export const getCommessaFormat = () => ({ ...FORMAT });

// Regex completa (con .X e -OFF opzionali) e solo-base, costruite al volo
export const commessaCodiceRe = () =>
  new RegExp(
    `^${FORMAT.prefix}-\\d{${FORMAT.cifreCliente}}-\\d{${FORMAT.cifreNumero}}(\\.\\d{1,2})?(-OFF)?$`,
    "i"
  );
export const commessaCodiceBaseRe = () =>
  new RegExp(
    `^${FORMAT.prefix}-\\d{${FORMAT.cifreCliente}}-\\d{${FORMAT.cifreNumero}}(\\.\\d{1,2})?$`,
    "i"
  );

// Esempio leggibile per messaggi/placeholder (es. "EG-XX-XXX")
export const commessaEsempio = () =>
  `${FORMAT.prefix}-${"X".repeat(FORMAT.cifreCliente)}-${"X".repeat(FORMAT.cifreNumero)}`;

// Retro-compat: alcune pagine usano COMMESSA_CODICE_RE.test(...)
export const COMMESSA_CODICE_RE = { test: (s) => commessaCodiceRe().test(s) };

// Maschera: prefisso fisso, trattini automatici. L'utente digita solo le
// cifre e opzionalmente "O" per il suffisso -OFF.
// `deleting=true` evita di ri-aggiungere il trattino appena cancellato.
export const maskCommessaCodice = (raw, { deleting = false } = {}) => {
  const up = (raw || "").toUpperCase();
  if (!up) return raw;
  const P = FORMAT.prefix;
  // Testo libero (es. ricerca per descrizione): maschera solo se "sembra un
  // codice" → inizia con una cifra oppure con un inizio del prefisso.
  const seemsCode =
    /^\d/.test(up) ||
    Array.from({ length: P.length }, (_, i) => P.slice(0, i + 1)).some(
      (pp) => up.startsWith(pp)
    );
  if (!seemsCode) return raw;
  // rimuovi il prefisso (anche parziale) e l'eventuale trattino iniziale
  let rest = up;
  for (let i = P.length; i > 0; i--) {
    if (up.startsWith(P.slice(0, i))) {
      rest = up.slice(i);
      break;
    }
  }
  rest = rest.replace(/^-/, "");
  const cc = FORMAT.cifreCliente;
  const cn = FORMAT.cifreNumero;
  // Iter 87: supporto sotto-commessa ".X" (es. EG-13-167.1)
  const hasDot = rest.includes(".");
  const [mainRaw, ...dotParts] = rest.split(".");
  const digits = mainRaw.replace(/\D/g, "").slice(0, cc + cn);
  const subDigits = hasDot
    ? dotParts.join("").replace(/\D/g, "").slice(0, 2)
    : "";
  const letters = rest.replace(/[^A-Z]/g, "");
  const wantsOff = letters.includes("O");
  let out = `${P}-`;
  if (digits.length <= cc) {
    out += digits;
    if (digits.length === cc && !deleting) out += "-";
  } else {
    out += `${digits.slice(0, cc)}-${digits.slice(cc)}`;
    if (digits.length === cc + cn) {
      if (hasDot) out += `.${subDigits}`;
      if (wantsOff && (!hasDot || subDigits)) out += "-OFF";
    }
  }
  return out;
};
